import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['field', 'submit'];

  connect() {
    this.checkFields();

    this.fieldTargets.forEach((field) => {
      field.addEventListener('input', () => this.checkFields());
      field.addEventListener('change', () => this.checkFields());
    });

    this.element.addEventListener('submit', (event) =>
      this.handleSubmit(event)
    );
  }

  checkFields() {
    // Separate radio card radio buttons, checkbox groups, and other fields
    const radioCardGroups = new Map();
    const checkboxGroups = new Map();
    const otherFields = [];

    this.fieldTargets.forEach((field) => {
      // Check if this radio button is inside a .m-survey__radio-card element
      if (field.type === 'radio' && field.closest('.m-survey__radio-card')) {
        const groupName = field.name;
        if (!radioCardGroups.has(groupName)) {
          radioCardGroups.set(groupName, []);
        }
        radioCardGroups.get(groupName).push(field);
      } else if (field.type === 'checkbox') {
        // Group checkboxes by name; a group is filled once at least one box in it is checked
        const groupName = field.name;
        if (!checkboxGroups.has(groupName)) {
          checkboxGroups.set(groupName, []);
        }
        checkboxGroups.get(groupName).push(field);
      } else {
        // Include all non-radio-card, non-checkbox fields (text, number, select, and other radio buttons)
        otherFields.push(field);
      }
    });

    // Check if at least one radio card radio button in each group is checked
    const allRadioCardGroupsFilled = Array.from(radioCardGroups.values()).every(
      (group) => group.some((radio) => radio.checked)
    );

    // Check if at least one checkbox in each group is checked
    const allCheckboxGroupsFilled = Array.from(checkboxGroups.values()).every(
      (group) => group.some((checkbox) => checkbox.checked)
    );

    // Check if all other fields (text, number, select, non-card radio buttons) have values
    const allOtherFieldsFilled = otherFields.every((field) => {
      if (field.type === 'radio') {
        // For non-card radio buttons, check if at least one in the group is checked
        const groupName = field.name;
        const groupRadios = Array.from(
          this.element.querySelectorAll(
            `input[type="radio"][name="${groupName}"]`
          )
        );
        return groupRadios.some((radio) => radio.checked);
      } else {
        return field.value && field.value.trim() !== '';
      }
    });

    const allFilled =
      (radioCardGroups.size === 0 || allRadioCardGroupsFilled) &&
      (checkboxGroups.size === 0 || allCheckboxGroupsFilled) &&
      allOtherFieldsFilled;
    this.submitTarget.disabled = !allFilled;

    if (radioCardGroups.size > 0) {
      this.submitTarget.style.opacity = allRadioCardGroupsFilled ? '1' : '0';
    }
  }

  handleSubmit() {
    this.submitTarget.disabled = true;
    document.body.style.cursor = 'wait';
  }
}
